import React from "react";
import constants from "../../utilities/constants.json";
import UserFaceAlt from "../../assets/img/avatar-face.jpg";
import { useNavigate } from "react-router-dom";

const imageUrl = constants.profile_image;

const ContestWinners = ({
  title = "Prediction Contest",
  allTimeWinners = [],
}) => {
  const navigate = useNavigate();
  if (!allTimeWinners?.length) return null;
  const firstPlace = allTimeWinners.find((w) => w?.position === "first_place");
  const secondPlace = allTimeWinners.find((w) => w?.position === "second_place");
  const thirdPlace = allTimeWinners.find((w) => w?.position === "third_place");

  const runners = allTimeWinners.filter(
    (w) => w?.position !== "first_place" && w?.position !== "second_place" &&
      w?.position !== "third_place"
  );

  const redirect = (data) => {
    if (localStorage.webKey) {
      navigate("/mobile-user-profile", {
        state: { rank: null, user_id: data.user?._id.$oid },
      });
    }
  };

  return (
    <div style={styles.container} className="container-drift">
      <div style={styles.topBorderBar} />



      {/* Header */}



      <div style={styles.header}>
        <span style={styles.seasonBadge}>FIFA World Cup 2026 Prediction Contest</span>
        <h1 style={styles.title}>
          {title} <span style={styles.titleRed}>Winners</span>
        </h1>
      </div>

      {/* Top Winners */}
      <div style={styles.topWinners}>
        {/* Second Place */}
        {secondPlace && (
          <div style={styles.secondPlace} onClick={() => redirect(secondPlace)}>
            <div style={styles.imageWrapperSmall}>
              <div style={styles.ringSilver}>
                <img
                  src={
                    secondPlace?.user?.image
                      ? imageUrl + secondPlace.user.image
                      : UserFaceAlt
                  }
                  alt={secondPlace?.user?.name}
                  style={styles.avatarImage}
                  onError={(e) => (e.target.src = UserFaceAlt)}
                />
              </div>
              <span style={styles.badgeSilver}>2nd</span>
            </div>

            <h3 style={styles.nameSecondary}>{secondPlace?.user?.name}</h3>
            <p style={styles.pointsSilver}>
              {(secondPlace?.score ?? 0).toLocaleString()} pts
            </p>
          </div>
        )}
        {/* First Place */}
        {firstPlace && (
          <div style={styles.firstPlace} onClick={() => redirect(firstPlace)}>
            <svg style={styles.crownIcon} viewBox="0 0 24 24" fill="currentColor">
              <path d="M5 16L3 7L8.5 11L12 4L15.5 11L21 7L19 16H5Z" />
              <rect x="5" y="18" width="14" height="4" rx="1.5" />
            </svg>

            <div style={styles.imageWrapperLarge}  >
              <div style={styles.ringGold} >
                <img
                  src={
                    firstPlace?.user?.image
                      ? imageUrl + firstPlace.user.image
                      : UserFaceAlt
                  }
                  alt={firstPlace?.user?.name}
                  style={styles.avatarImage}
                  onError={(e) => (e.target.src = UserFaceAlt)}
                />
              </div>
              <span style={styles.badgeGold}>1st</span>
            </div>

            <h3 style={styles.namePrimary}>{firstPlace?.user?.name}</h3>
            <p style={styles.pointsGold}>
              {(firstPlace?.score ?? 0).toLocaleString()} pts
            </p>
          </div>
        )}



        {/* Third Place */}
        {thirdPlace && (
          <div style={styles.thirdPlace} onClick={() => redirect(thirdPlace)}>
            <div style={styles.imageWrapperSmall}>
              <div style={styles.ringBronze}>
                <img
                  src={
                    thirdPlace?.user?.image
                      ? imageUrl + thirdPlace.user.image
                      : UserFaceAlt
                  }
                  alt={thirdPlace?.user?.name}
                  style={styles.avatarImage}
                  onError={(e) => (e.target.src = UserFaceAlt)}
                />
              </div>
              <span style={styles.badgeBronze}>3rd</span>
            </div>

            <h3 style={styles.nameTertiary}>{thirdPlace?.user?.name}</h3>
            <p style={styles.pointsBronze}>
              {(thirdPlace?.score ?? 0).toLocaleString()} pts
            </p>
          </div>
        )}
      </div>

      {/* Runners */}
      {runners.length > 0 && (
        <div style={styles.runnersSection}>
          <div style={styles.runnersTitleContainer}>
            <span style={styles.runnersBar} />
            <h2 style={styles.runnersTitle}>RUNNERS UP</h2>
          </div>

          <div style={styles.runnersGrid}>
            {runners.map((runner, index) => (
              <div
                key={index}
                style={styles.runnerCard}
                onClick={() => redirect(runner)}
              >
                <div style={styles.imageWrapperRunner}>
                  <div style={styles.ringRunner}>
                    <img
                      src={
                        runner?.user?.image
                          ? imageUrl + runner.user.image
                          : UserFaceAlt
                      }
                      alt={runner?.user?.name}
                      style={styles.avatarImage}
                      onError={(e) => (e.target.src = UserFaceAlt)}
                    />
                  </div>
                </div>

                <h3 style={styles.runnerName}>{runner?.user?.name}</h3>
                <p style={styles.runnerPoints}>
                  {(runner?.score ?? 0).toLocaleString()} pts
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "520px",
    margin: "0 auto",
    paddingHorizontal: "10px",
    paddingTop: "10px",
    paddingBottom: "3px",
    marginBottom: "-13px",
    background: "#f2f8fe",
    backgroundSize: "200% 200%",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(23, 86, 123, 0.24)",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
    position: "relative",
    overflow: "hidden",
  },

  topBorderBar: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "4px",
    background:
      "linear-gradient(90deg, \
rgba(37,99,235,0) 0%, \
rgba(37,99,235,0.15) 10%, \
rgba(37,99,235,0.5) 20%, \
rgba(22,163,74,0.85) 35%, \
rgba(220,38,38,0.85) 65%, \
rgba(220,38,38,0.5) 80%, \
rgba(220,38,38,0.15) 90%, \
rgba(220,38,38,0) 100%)",

    zIndex: 2,
  },

  header: { textAlign: "center", marginBottom: "8px" },
  seasonBadge: {
    display: "inline-block",
    padding: "2px 12px",
    backgroundColor: "#f3f8fa",
    color: "#083fb5",
    marginBottom: 5,
    border: "1px solid #bcdcff",
    borderRadius: "9999px",
    fontSize: "9px",
    fontWeight: "700",
    letterSpacing: "0.01em",
  },
  title: { fontSize: "14px", fontWeight: "700", margin: "4px 0 0" },
  titleRed: { color: "#a51b1b" },

  topWinners: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    gap: "25px",
    marginBottom: "8px",
  },

  firstPlace: { display: "flex", flexDirection: "column", alignItems: "center" },
  secondPlace: { display: "flex", flexDirection: "column", alignItems: "center" },

  crownIcon: {
    width: "16px",
    height: "16px",
    color: "#211d8f",
    marginBottom: "1px",
  },

  imageWrapperLarge: { position: "relative", marginBottom: "3px" },
  imageWrapperSmall: { position: "relative", marginBottom: "3px" },
  imageWrapperRunner: { position: "relative", marginBottom: "6px" },

  /* 🥇 GOLD */
  ringGold: {
    width: "74px",
    height: "74px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #1d458f",
    background: `
      radial-gradient(
        circle at 30% 30%,
        #ffeaea 0%,
        #f9caca 22%,
        #c12b2b 55%,
        #8f1d1d 100%
      )
    `,
    marginBottom: "2px"
  },

  /* 🥈 SILVER */
  ringSilver: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #920707",
    background: `
      radial-gradient(
        circle at 30% 30%,
        #f1f5f9 0%,
        #d1d5db 25%,
        #9ca3af 55%,
        #6b7280 80%,
        #4b5563 100%
      )
    `,
    boxShadow: `
      inset 0 2px 3px rgba(255,255,255,0.35),
      inset 0 -3px 5px rgba(0,0,0,0.35),
      0 0 0 2px rgba(156,163,175,0.35),
      0 0 8px rgba(148,163,184,0.35)
    `,
  },

  ringRunner: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #e5e7eb",
  },

  badgeGold: {
    position: "absolute",
    bottom: "-3px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "0px 7px",
    backgroundColor: "#211d8f",
    color: "#fff",
    borderRadius: "9999px",
    fontSize: "8px",
    fontWeight: "700",
  },

  thirdPlace: { display: "flex", flexDirection: "column", alignItems: "center" },




  ringBronze: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #92400e",
    background: `
      radial-gradient(
        circle at 30% 30%,
        #fef3c7 0%,
        #fbbf6f 25%,
        #d97706 55%,
        #92400e 100%
      )
    `,
    boxShadow: `
      inset 0 2px 3px rgba(255,255,255,0.35),
      inset 0 -3px 5px rgba(0,0,0,0.35),
      0 0 0 2px rgba(146,64,14,0.35),
      0 0 8px rgba(217,119,6,0.35)
    `,
  },

  badgeBronze: {
    position: "absolute",
    bottom: "-3px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "0px 7px",
    backgroundColor: "#92400e",
    color: "#fff",
    borderRadius: "9999px",
    fontSize: "8px",
    fontWeight: "700",
  },

  nameTertiary: {
    fontSize: "10px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "6px",
    marginTop: "2px",
  },

  pointsBronze: { fontSize: "9px", fontWeight: "600", color: "#92400e" },

  badgeSilver: {
    position: "absolute",
    bottom: "-3px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "0px 7px",
    backgroundColor: "#920707",
    color: "#fff",
    borderRadius: "9999px",
    fontSize: "8px",
    fontWeight: "700",
  },

  namePrimary: {
    fontSize: "12px",
    fontWeight: "700",
    textAlign: "center",
    marginTop: "2px",
  },
  nameSecondary: {
    fontSize: "10px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "6px",
    marginTop: "2px",
  },

  pointsGold: { fontSize: "10px", fontWeight: "700", color: "#a51b1b" },
  pointsSilver: { fontSize: "9px", fontWeight: "600", color: "#64748b" },

  avatarImage: { width: "100%", height: "100%", objectFit: "cover" },

  runnersSection: { marginTop: "16px" },

  runnersTitleContainer: {
    position: "relative",
    paddingLeft: "10px",
    marginBottom: "10px",
  },
  runnersBar: {
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    width: "3px",
    height: "12px",
    backgroundColor: "#d1d5db",
    borderRadius: "2px",
  },
  runnersTitle: {
    fontSize: "9px",
    fontWeight: "600",
    color: "#6b7280",
    letterSpacing: "0.08em",
    margin: 0,
  },

  runnersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "10px",
  },

  runnerCard: {
    backgroundColor: "#f9fafb",
    borderRadius: "10px",
    padding: "10px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  runnerName: {
    fontSize: "11px",
    fontWeight: "700",
    textAlign: "center",
    height: "26px",
    overflow: "hidden",
  },

  runnerPoints: {
    fontSize: "9px",
    color: "#6b7280",
    marginTop: "2px",
  },
};

export default ContestWinners;
